export default "__VITE_ASSET__BmKj4sIj__"